(function () {
  "use strict";

  /**
   * 商品ページの共通処理
   */

  // 定数
  const SCROLL_ADJUST_POSITION = 500;
  const DESKTOP_BREAKPOINT = 1080;
  const PARALLAX_DIVISOR_DESKTOP = 4;
  const PARALLAX_DIVISOR_MOBILE = 3;

  /**
   * アプリからの遷移時に購入フォームを非表示にする
   */
  const hidePurchaseForm = () => {
    const productForm = document.getElementById("product-form");
    if (!productForm) return;

    const url = new URL(window.location.href);
    const referParam = url.searchParams.get("refer");

    if (referParam === "app") {
      productForm.style.display = "none";
    }
  };

  /**
   * レビュー評価の表示はサーバ描画（product-review-rating.liquid）を恒久利用する。
   * アプリ(mxpr)の .star-ratings-css は★を整数（5段階）に丸めるため、平均4.9でも
   * ★★★★☆と過小表示されてしまう。サーバ描画は star-rating-fill を
   * width:(stars/5*100)% の連続塗りで描くため小数第一位まで正確に表現できる
   * （メタフィールド prime_review.summary.stars が信頼ソース）。
   * よってアプリ版★での上書き（旧 cloneReviewRating）は廃止した。
   * 2026-06: レビュー★が過小評価される問題の修正（Option1: 連続塗りで小数表現）。
   */

  /**
   * スクロールに応じたパララックス効果
   */
  const initParallaxScroll = () => {
    const scrollXElement = document.querySelector(".scroll-x");
    if (!scrollXElement) return;

    let initialLeft = 0;
    let isDesktop = false;

    const updateMetrics = () => {
      const initialRect = scrollXElement.getBoundingClientRect();
      initialLeft = initialRect.left + window.pageXOffset;
      isDesktop = window.matchMedia(
        `(min-width: ${DESKTOP_BREAKPOINT}px)`
      ).matches;
    };

    // 初期計算
    updateMetrics();

    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollY =
            window.pageYOffset || document.documentElement.scrollTop;
          const divisor = isDesktop
            ? PARALLAX_DIVISOR_DESKTOP
            : PARALLAX_DIVISOR_MOBILE;
          scrollXElement.style.left = `${initialLeft - scrollY / divisor}px`;
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    let resizeTimer;
    window.addEventListener(
      "resize",
      () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateMetrics, 200);
      },
      { passive: true }
    );
  };

  /**
   * カート追加ボタンの固定表示制御
   */
  const initStickyCartButton = () => {
    const target = document.querySelector(".product-form__cart-submit-box");
    if (!target) return;

    let fixedBound = 0;

    const updateMetrics = () => {
      const viewHeight = document.documentElement.clientHeight;
      const targetHeight = target.getBoundingClientRect().height;
      fixedBound = viewHeight - targetHeight;
    };

    // 初期計算
    updateMetrics();

    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollTop =
            document.documentElement.scrollTop - SCROLL_ADJUST_POSITION;
          target.classList.toggle("is-fixed", scrollTop > fixedBound);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    let resizeTimer;
    window.addEventListener(
      "resize",
      () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateMetrics, 200);
      },
      { passive: true }
    );
  };

  // 初期化
  document.addEventListener("DOMContentLoaded", () => {
    hidePurchaseForm();
    initParallaxScroll();
    initStickyCartButton();
  });
})();
